const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist-variants";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";

const selectors = {
  button: ".slide-wishlist-button",
  grid: ".wishlist-items .splide__list",
  productCard: ".product-card",
};

document.addEventListener("DOMContentLoaded", () => {
  // Initialize wishlist functionality
  initializeWishlist();
  
  initButtons();
  initGrid();

  // Listen for variant changes to update button states
  // Common Shopify variant change events
  document.addEventListener("variant:change", updateButtonStates);
  document.addEventListener("product:variant-change", updateButtonStates);
  document.addEventListener("product:variant:change", updateButtonStates);
  document.addEventListener("variantChange", updateButtonStates);
  document.addEventListener("variant-change", updateButtonStates);

  // Listen for form changes that might indicate variant selection
  document.addEventListener("change", (e) => {
    if (
      e.target.name === "id" ||
      e.target.closest("[data-product-form]") ||
      e.target.closest(".product-form")
    ) {
      setTimeout(updateButtonStates, 100); // Small delay to ensure variant is updated
    }
  });

  // Fallback: periodically check for variant changes
  setInterval(() => {
    if (
      window.theme &&
      window.theme.product &&
      window.theme.product.currentVariant
    ) {
      updateButtonStates();
    }
  }, 1000);
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  console.log("[Shopify Wishlist] Wishlist Updated ✅", {
    wishlist: event.detail.wishlist
  });
  initGrid();
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Product List Loaded ✅",
    event.detail.wishlist
  );
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Buttons Loaded ✅",
    event.detail.wishlist
  );
});

const fetchVariantCardHTML = (variantId, discountPercent = 0) => {
  // Fetch variant information using Shopify's Product API
  console.log(`[Wishlist] Fetching variant data for ID: ${variantId}`);

  // Try multiple endpoints to find the variant
  const endpoints = [
    `/products.json?limit=250`,
    `/search?q=&type=product&view=json`,
    `/collections/all/products.json?limit=250`,
  ];

  const tryEndpoint = async (endpoint) => {
    try {
      const response = await fetch(endpoint);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(
        `[Wishlist] Failed to fetch from ${endpoint}:`,
        error.message
      );
      return null;
    }
  };

  return (async () => {
    let productsData = null;

    // Try each endpoint until we get data
    for (const endpoint of endpoints) {
      const data = await tryEndpoint(endpoint);
      if (data && data.products && data.products.length > 0) {
        productsData = data;
        break;
      }
    }

    if (!productsData) {
      console.error(`[Wishlist] Could not fetch products from any endpoint`);
      throw new Error("Could not fetch products data");
    }

    // Find the product and variant
    let foundVariant = null;
    let foundProduct = null;

    productsData.products.forEach((product) => {
      const variant = product.variants.find(
        (v) => v.id.toString() === variantId.toString()
      );
      if (variant) {
        foundVariant = variant;
        foundProduct = product;
      }
    });

    if (!foundVariant || !foundProduct) {
      console.error(
        `[Wishlist] Variant ${variantId} not found in any products data`
      );
      throw new Error(`Variant ${variantId} not found`);
    }

    console.log(
      `[Wishlist] Found variant:`,
      foundVariant,
      "in product:",
      foundProduct
    );

    // Note: Variant-specific metafield discounts are not available through the standard API
    // The wishlist will use global discount lists which are working correctly

    // Create HTML for the variant card
    return createVariantCardHTML(foundProduct, foundVariant, discountPercent);
  })().catch((err) => {
    console.error(
      `[Shopify Wishlist] Failed to load content for variant: ${variantId}`,
      err
    );
    return "";
  });
};

const createVariantCardHTML = (product, variant, discountPercent = 0) => {
  const image =
    variant.featured_image ||
    (product.images.length > 0 ? product.images[0] : null);

  // Calculate pricing with discount if applicable
  let priceHTML = '';
  let originalPrice = variant.price // Convert cents to dollars
  let discountedPrice = originalPrice;

  // Apply discount if there's a discount percentage from the wishlist data
  if (discountPercent && discountPercent > 0) {
    discountedPrice = originalPrice * (1 - discountPercent / 100);
    
    priceHTML = `
      <span class="price price--on-sale mr-0">$${discountedPrice}</span>
      <span class="price price--compare">$${originalPrice}</span>
    `;
  } else {
    priceHTML = `<span class="price">$${originalPrice}</span>`;
  }

  return `
    <div class="wishlist-item splide__slide" data-variant-id="${variant.id}">
      <div class="wishlist-item-image">
      <button class="slide-wishlist-button active" onclick="removeFromWishlist('${
            variant.id
          }')">
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.19413 1.54345C5.21259 1.54225 4.25083 1.81538 3.42058 2.33112C2.59033 2.84686 1.92564 3.58405 1.50372 4.45706C1.08181 5.33007 0.919973 6.30308 1.03702 7.26307C1.15407 8.22307 1.54519 9.13065 2.16496 9.88042L6.32485 14.6902L10.4847 19.5L18.7225 9.97636L18.7635 9.93092L18.8045 9.88042C19.2544 9.34594 19.5892 8.72682 19.7884 8.06078C19.9875 7.39475 20.047 6.69574 19.9631 6.00634C19.8792 5.31695 19.6537 4.65159 19.3003 4.05082C18.9469 3.45005 18.4731 2.92643 17.9077 2.51186C17.3422 2.09729 16.697 1.80046 16.0114 1.63945C15.3258 1.47843 14.614 1.4566 13.9195 1.57529C13.2251 1.69398 12.5624 1.9507 11.9719 2.32981C11.3813 2.70892 10.8754 3.20249 10.4847 3.78045C10.0101 3.09124 9.37139 2.52702 8.62435 2.13707C7.87731 1.74712 7.0447 1.54331 6.19926 1.54345H6.19413Z" stroke="#003057" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
        ${
          image
            ? `<img src="${image.src}" alt="${
                image.alt || product.title
              }" loading="lazy">`
            : ""
        }
      </div>
      <div class="wishlist-item-details">
        <h3 class="wishlist-item-title">
          <a href="/products/${product.handle}?variant=${variant.id}">${
    product.title
  }</a>
        </h3>
        <p class="wishlist-item-variant mb-0">${variant.title}</p>
        <div class="wishlist-item-price">
          ${priceHTML}
        </div>
        <div class="wishlist-item-actions">
          <a class="btn btn--primary" href="/cart/add?id=${
            variant.id
          }&quantity=1">Add to Cart</a>
          <button class="btn btn--secondary" onclick="removeFromWishlist('${
            variant.id
          }')">Remove</button>
        </div>
      </div>
    </div>
  `;
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const variantIds = Object.keys(wishlist);

  if (variantIds.length === 0) {
    
    grid.innerHTML = '<p class="wishlist-empty">Your wishlist is empty.</p>';
    grid.classList.add(GRID_LOADED_CLASS);
    return;
  }


  try {
    const requests = variantIds.map(variantId => fetchVariantCardHTML(variantId, wishlist[variantId]));
    const responses = await Promise.all(requests);
    const wishlistVariantCards = responses.filter((html) => html).join("");



    if (wishlistVariantCards) {
      grid.innerHTML = wishlistVariantCards;
      
    } else {
      grid.innerHTML =
        '<p class="wishlist-empty">Failed to load wishlist items.</p>';

    }

    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();
    
    // Initialize Splide slider after items are loaded
    if (wishlistVariantCards) {
      new Splide(".wishlist-items", {
        perPage: 1,
        autoWidth: true,
        gap: 0,
        pagination: false,
        type: "slide",
        arrows: true,
        classes: {
          arrows: "wishlist-items splide__arrows",
          arrow: "wishlist-items splide__arrow",
          prev: "wishlist-items splide__arrow--prev",
          next: "wishlist-items splide__arrow--next",
        },
      }).mount();
    }
  } catch (error) {
    
    grid.innerHTML =
      '<p class="wishlist-empty">Error loading wishlist items.</p>';
    grid.classList.add(GRID_LOADED_CLASS);
  }
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    // Set initial button state
    const initialVariantId = getVariantIdFromButton(button);
    if (initialVariantId && wishlistContains(initialVariantId)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    }

    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Get the current variant ID at the time of click
      const currentVariantId = getVariantIdFromButton(button);
      if (!currentVariantId) {
        console.error(
          "[Shopify Wishlist] Missing variant ID. Failed to update the wishlist."
        );
        return;
      }

      const wasInWishlist = wishlistContains(currentVariantId);
      updateWishlist(currentVariantId);

      // Update button state based on current wishlist status
      if (wishlistContains(currentVariantId)) {
        button.classList.add(BUTTON_ACTIVE_CLASS);
        // Show notification only when adding to wishlist (not when removing)
        if (!wasInWishlist) {
          showWishlistNotification();
        }
      } else {
        button.classList.remove(BUTTON_ACTIVE_CLASS);
      }
    });
  });
};

const getVariantIdFromButton = (button) => {
  // Use the dynamic currentVariant from window.theme if available
  if (
    window.theme &&
    window.theme.product &&
    window.theme.product.currentVariant
  ) {
    return window.theme.product.currentVariant.id.toString();
  }

  // Fallback: Try to get variant ID from data attribute
  if (button.dataset.variantId) {
    return button.dataset.variantId;
  }

  // Fallback: Try to find variant ID from closest form
  const form = button.closest("form");
  if (form) {
    const variantInput = form.querySelector(
      'input[name="id"], select[name="id"]'
    );
    if (variantInput) {
      return variantInput.value;
    }
  }

  // Fallback: Try to find variant ID from product form context
  const productForm = button.closest(".product-form, [data-product-form]");
  if (productForm) {
    const variantInput = productForm.querySelector(
      'input[name="id"], select[name="id"]'
    );
    if (variantInput) {
      return variantInput.value;
    }
  }

  return null;
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid);
  if (grid) {
    setupGrid(grid).then(() => {
      document.dispatchEvent(
        new CustomEvent("shopify-wishlist:init-product-grid", {
          detail: { wishlist: getWishlist() },
        })
      );
    });
  }
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button);
  if (buttons.length) {
    setupButtons(buttons);
  }
  document.dispatchEvent(
    new CustomEvent("shopify-wishlist:init-buttons", {
      detail: { wishlist: getWishlist() },
    })
  );
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  if (wishlist) {
    try {
      // Try to parse as JSON object first (new format)
      const parsed = JSON.parse(wishlist);
      if (typeof parsed === 'object' && parsed !== null) {
        return parsed;
      }
    } catch (e) {
      // If JSON parsing fails, handle old format (comma-separated string)
      const oldFormatIds = wishlist.split(LOCAL_STORAGE_DELIMITER).filter((id) => id);
      // Convert old format to new format
      const newFormat = {};
      oldFormatIds.forEach(id => {
        newFormat[id] = 0; // Default discount of 0 for existing items
      });
      return newFormat;
    }
  }
  return {};
};

const setWishlist = (wishlistObject) => {
  if (Object.keys(wishlistObject).length > 0) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, JSON.stringify(wishlistObject));
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  document.dispatchEvent(
    new CustomEvent("shopify-wishlist:updated", {
      detail: { 
        wishlist: wishlistObject
      },
    })
  );
  return wishlistObject;
};

const updateWishlist = (variantId) => {
  const wishlist = getWishlist();
  const variantIdStr = variantId.toString();

  // Get current variant discount value
  const currentVariantDiscount = window.theme?.product?.currentVariant?.discount || 
                                 window.shopSettings?.variant_discounts?.[variantId]?.discount_percent || 
                                 0;

  if (wishlist.hasOwnProperty(variantIdStr)) {
    // Remove from wishlist
    delete wishlist[variantIdStr];
  } else {
    // Add to wishlist with discount value
    wishlist[variantIdStr] = currentVariantDiscount;
  }

  return setWishlist(wishlist);
};

const wishlistContains = (variantId) => {
  const wishlist = getWishlist();
  return wishlist.hasOwnProperty(variantId.toString());
};

const getWishlistCount = () => {
  return Object.keys(getWishlist()).length;
};

// Helper functions for wishlist actions
const addToCart = (variantId) => {
  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      
      // Trigger cart update event if your theme uses it
      document.dispatchEvent(new CustomEvent("cart:updated"));
    })
    .catch((error) => {
      
    });
};

const removeFromWishlist = (variantId) => {
  updateWishlist(variantId);
  // Refresh the grid
  initGrid();
  // Note: We don't show notification for removal actions from the grid
};

// Initialize wishlist functionality
const initializeWishlist = () => {
  console.log('[Wishlist] Initializing wishlist functionality');
  
  // Ensure shopSettings is available
  if (!window.shopSettings) {
    console.warn('[Wishlist] Global shopSettings not found, discount functionality may be limited');
    window.shopSettings = {
      enable_sku_discounts: false,
      discount_per_1: 0,
      discount_per_2: 0,
      discount_per_3: 0,
      discount_products_1: [],
      discount_products_2: [],
      discount_products_3: [],
      discount_message: '',
      variant_discounts: {}
    };
  }
};

// Update button states when variant changes
const updateButtonStates = () => {
  const buttons = document.querySelectorAll(selectors.button);
  buttons.forEach((button) => {
    const currentVariantId = getVariantIdFromButton(button);
    if (currentVariantId) {
      const isInWishlist = wishlistContains(currentVariantId);
      if (isInWishlist) {
        button.classList.add(BUTTON_ACTIVE_CLASS);
      } else {
        button.classList.remove(BUTTON_ACTIVE_CLASS);
      }
    } else {
      // If no variant ID found, ensure button is not active
      button.classList.remove(BUTTON_ACTIVE_CLASS);
    }
  });
};

// Show wishlist notification
const showWishlistNotification = () => {
  const notification = document.querySelector('.wishlist-notification');
  if (notification) {
    // Make the notification visible
    notification.style.opacity = '1';
    notification.style.pointerEvents = 'auto';

    
    // Hide the notification after 3 seconds
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.pointerEvents = 'none';
    }, 5000);
  }
};
